// import debounce from 'lodash-es/debounce';
import {MenuManager, MS} from '../../../../../functions/menu';

namespace categoriesMenu {

  // Handlers and elements for a category pane
  class Category {
    menuManager : MenuManager;
    menuButton  : HTMLElement;

    constructor(id: string) {
      this.menuButton = <HTMLElement> document.querySelector('.' + id);

      const menuHeight  = 0;
      const menuElement = <HTMLElement> document.getElementById(id);
      this.menuManager = new MenuManager(menuHeight, menuElement, this.closeHandler);

      this.menuButton.addEventListener('click', this.clickHandlerMenu, false);
    }
    
    clickHandlerMenu = (event: MouseEvent) => {
      if (this.menuManager.menuState == MS.open) {
        this.menuButton.classList.remove('active');
        this.menuManager.menuClose('ease-in');
        event.stopPropagation();
      }
      else {
        // Get animation before the other menus are closed
        const animation = !this.hasOtherOpenCategory() ? 'ease-in' : '';

        // Close other open categories      
        categories.forEach(category => category.closeCategory());
      
        // Open category
        this.menuButton.classList.add('active');
        this.menuManager.menuOpen(animation);
        event.stopPropagation();
      }  
    }

    closeHandler = () => {
      this.menuButton.classList.remove('active');
    }

    closeCategory() {
      this.menuButton.classList.remove('active');
      this.menuManager.menuClose();  
    }

    openCategory() {
      this.menuButton.classList.add('active');
      this.menuManager.menuOpen();  
    }

    hasOtherOpenCategory() {
      const openAmount = categories
        .filter(category => category.menuManager.menuState == MS.open)
        .filter(category => category != this)
        .length;
      return openAmount > 0;
    }
  }

  
  function windowWatcher(categories: Category[]) {

    const mediaQuery = window.matchMedia('print, (min-width: 992px)');
    mediaQuery.addListener(mqListener);
    mqListener(mediaQuery);

    function mqListener(mediaQuery: MediaQueryList | MediaQueryListEvent) {
      // Unregister hammer handlers if screen is large
      if (mediaQuery.matches) {
        categories.forEach(category => category.menuManager.unregisterHandlers());
        categories.forEach(category => category.openCategory());
      }
      // Reregister if screen is small
      else {
        categories.forEach(category => category.menuManager.registerHandlers());
        categories.forEach(category => category.closeCategory());
      }
    }
  }


  // Helper function for converting node lists to arrays
  function a(elements: HTMLCollection | NodeListOf<Element>): HTMLElement[] {
    return Array.prototype.slice.call(elements);
  }

  // Initializes all categories
  function scanAndInitCategories(menuClass: string): Category[] {
    let categories: Category[] = [];
    const menuItems = a(document.querySelectorAll(menuClass + ' li'));
    for (const menuItem of menuItems) {
      if (menuItem.classList[0]) {
        const id = menuItem.classList[0];
        categories.push(new Category(id));
      }
    }
    return categories;
  }
    
  // Main
  let categories = scanAndInitCategories('.category-menu-section');
  windowWatcher(categories);

}
